import axios from './api';

export const login = async (url: string, payload: any) => {
	const response = await axios.post(url, payload);

	return response;
};
